'use client';
import clsx from 'clsx';

import ZaloIcon from '@public/icons/icon-zalo.svg';
import { zaloLink } from 'lib/constants';
import { useScrollVisibility } from 'hooks/useScrollVisibility';

interface ZaloWidgetProps {
  locale?: string;
}

function ZaloWidget({ locale }: Readonly<ZaloWidgetProps>) {
  const isVisible = useScrollVisibility();

  if (locale !== 'vi') return null;

  return (
    <div
      data-testid="zalo-widget-container"
      className={clsx(
        'fixed right-[0.9rem] z-50',
        isVisible && 'sm:bottom-[11.25rem] md:bottom-[11.875rem]',
        !isVisible && 'sm:bottom-[4.25rem] md:bottom-[4.875rem]'
      )}
    >
      <a
        className={clsx(
          'fixed right-[1.375rem] z-50 w-[60px] h-[60px]',
          isVisible && 'sm:bottom-[10.25rem] md:bottom-[10.875rem]',
          !isVisible && 'md:bottom-[4.875rem] sm:bottom-[4.25rem]'
        )}
        href={`${zaloLink}`}
        target="_blank"
        rel="noreferrer noopener"
      >
        <ZaloIcon />
      </a>
    </div>
  );
}

export default ZaloWidget;
